import React from "react";
import {Link} from "react-router-dom";

class Promotion extends React.Component {
  render() {
    const clearStyle = {
      clear: "both"
    };
    const PaddingStyle = {
      paddingLeft: "5%",
      paddingRight: "5%"
    };

    const strongStyle = {
      fontSize: "1.2em"
    };

    const strongStyleBlue = {
      fontSize: "1.2em",
      color: "#0076be"
    };
    return (
        <section className="section reason-section" style={{background: "#fff", padding: "100px 0"}}>

          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="ReasonSvg">
                  <div className="MapImage"><img src="/images/reason.svg" alt="" className="img-fluid mx-auto d-block"/></div>
                </div>
              </div>

              <div className="col-lg-1"></div>

              <div className="col-lg-6">
                <div className="mt-3 features_desc">
                  <h1 className="Title reason">5 reasons<br/><span className="s_Title">why you’ll love using MightyWifi</span></h1>

                  <div className="col-lg-12 no-padding">
                    <ol className="ReasonList">
                      <li className="reason-list"><strong className="bluetitle">WiFi Anywhere</strong><br/>Connect locally & over 200 countries</li>
                      <li className="reason-list"><strong className="bluetitle">Share among 10 devices</strong><br/>Connect your friends and family</li>
                      <li className="reason-list"><strong className="bluetitle">Pay for only what you use</strong><br/>No contracts. No overage charges</li>
                      {/*<li className="reason-list"><strong className="bluetitle">Unlimited data</strong><br/>Never worry about running out of data<br/>(after data cap, the speed reduces to 128kbps)</li>*/}
                      <li className="reason-list"><strong className="bluetitle">Flexible data</strong><br/>No contracts, pay as you need. Flexible data size plans available</li>
                      <li className="reason-list"><strong className="bluetitle">Easy and Secure</strong><br/>SIM-free, hassle-free</li>
                    </ol>
                  </div>

                  <div style={clearStyle} />
                </div>
              </div>
            </div>
          </div>

        </section>
    );
  }
}

export default Promotion;



// WEBPACK FOOTER //
// ./src/layout/Reason.js